import { render, staticRenderFns } from "./ScansForm.vue?vue&type=template&id=572e3150&scoped=true&"
import script from "./ScansForm.vue?vue&type=script&lang=js&"
export * from "./ScansForm.vue?vue&type=script&lang=js&"
import style0 from "./ScansForm.vue?vue&type=style&index=0&id=572e3150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e3150",
  null
  
)

component.options.__file = "ScansForm.vue"
export default component.exports